import riot from 'riot';
import events from '../src/events.js';
import { getLessons as libGetLessons } from '../src/lib.js';
riot.tag2('lessons', '<div class="column is-12" style="margin-top: -75px;"> <nav class="navbar" role="navigation" aria-label="main navigation" if="{!selectedLesson && !showBuildLesson}" style="background-color: rgb(245,245,245);"> <div class="navbar-menu is-active"> <div class="navbar-start"> <div class="navbar-item"> <div class="field has-addons has-addons-centered"> <div class="control is-expanded"> <input class="input is-fullwidth" type="text" oninput="{filterLessons}" id="filterLessonsInput" placeholder="Search Lessons"> </div> <div class="control"> <button class="button is-info" type="button" onclick="{filterLessons}"> <span class="icon"> <i class="fas fa-search"></i> </span> </button> </div> </div> </div> <div class="navbar-item"> <div class="field is-grouped is-grouped-multiline"> <div class="control"> <div class="select"> <select id="gradeFilterSelect" onchange="{filterLessons}"> <option value="">All Grade Levels</option> <option each="{grade in availableGrades}" riot-value="{grade}">Grade {grade}</option> </select> </div> </div> <div class="control"> <button class="button {myLessonsFilterActive ? \'is-info\' : \'is-info is-light\'}" type="button" onclick="{toggleMyLessonsFilter}" show="{user}"> <span class="icon is-small"><i class="fas fa-user"></i></span> <span>{myLessonsFilterActive ? \'Show All Lessons\' : \'Show My Lessons\'}</span> </button> </div> <div class="control"> <button class="button {showCommunityContent ? \'is-link\' : \'is-link is-light\'}" type="button" onclick="{toggleCommunityContent}"> <span class="icon is-small"><i class="fas fa-globe"></i></span> <span>{showCommunityContent ? \'Hide Community\' : \'Show Community\'}</span> </button> </div> <div class="control" if="{hasActiveFilters()}"> <button class="button is-light" onclick="{clearFilters}"> <span class="icon is-small"> <i class="fas fa-times"></i> </span> <span>Clear Filters</span> </button> </div> </div> </div> </div> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-success" onclick="{buildLessonClick}" if="{user}"> <span class="icon is-small"> <i class="fas fa-plus"></i> </span> <span>Create New Lesson</span> </button> <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </button> </div> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{loading_lessons}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{!loading_lessons && !selectedLesson && !showBuildLesson}" style="margin-top: 5px;"> <div class="column is-4" each="{l in filteredLessons}" if="{!lessons_error}"> <div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content" style="flex: 1 1 auto; display: flex; flex-direction: column;"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{l.icon}" alt="Lesson Icon" onerror="this.onerror=null; this.src=\'img/brand/Edjro_Logo_Mark_Navy.png\';"> </figure> </div> <div class="media-content"> <p class="title is-4">{l.name}</p> <p class="subtitle is-6">Author: {l.author?l.author.first_name + ⁗ ⁗ + l.author.last_name:⁗⁗}</p> </div> </div> <div class="notification is-info is-light has-text-centered" if="{l.status === \'draft\'}"> <span class="icon"><i class="fas fa-pencil-alt"></i></span> Draft — Only visible to you </div> <div class="notification is-warning is-light has-text-centered" if="{lessonHasActivity(l)}"> In Progress </div> <div class="content" style="display: flex; flex-direction: column; flex: 1 1 auto;"> <div class="field is-grouped is-grouped-multiline"> <div class="control"> <div class="tags has-addons"> <span class="tag is-medium is-dark">Grade Level</span> <span class="tag is-medium is-info">{l.grade_level}</span> </div> </div> </div> <div class="field is-grouped is-grouped-multiline"> <div class="control"> <div class="tags has-addons"> <span class="tag is-medium is-dark">Prep Time</span> <span class="tag is-medium is-primary">{l.prep_time}</span> </div> </div> <div class="control"> <div class="tags has-addons"> <span class="tag is-medium is-dark">Lesson Time</span> <span class="tag is-medium is-primary">{l.lesson_time}</span> </div> </div> </div> <div class="notification is-light"> <div class="field"> <label class="label">Lesson Focus</label> <div class="control"> <span>{l.focus}</span> </div> </div> </div> <div class="notification is-light"> <div class="field"> <label class="label">Lesson Objectives</label> <div class="control"> <ul class="tags has-addons"> <li each="{o in l.objectives}">{o}</li> </ul> </div> </div> </div> <div class="buttons" style="margin-top: auto"> <button id="viewDetails" class="button is-info" onclick="{selectLesson}"> View Lesson Details </button> </div> </div> </div> </div> </div> <div class="column is-12" if="{lessons_error}"> <article class="message is-danger"> <div class="message-header"> <p>Oh No!</p> <button class="delete" aria-label="delete"></button> </div> <div class="message-body"> It looks like there was an error loading the lessons from the library! Try to refresh the page and if the problem persists, please check out status page to see if there are any ongoing issues. Thank you for you patience! <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh Lessons</span> </button> </div> </article> </div> </div> <lesson-details if="{selectedLesson}"></lesson-details> <lesson-build if="{showBuildLesson}" build_type="lesson" edit_mode="{editMode}" lesson_to_edit="{lessonToEdit}" has_active_activities="{lessonHasActiveActivity}"></lesson-build> </div>', '', '', function(opts) {
        var self = this;
        self.loading_lessons = false;
        self.selectedLesson = undefined;
        self.devices = undefined;
        self.startingActivity = false;
        self.showBuildLesson = false;
        self.editMode = false;
        self.lessonToEdit = undefined;
        self.lessonHasActiveActivity = false;
        self.userActivities = undefined;
        self.lessons = [];
        self.filteredLessons = [];
        self.availableGrades = [];
        self.showCommunityContent = false;
        self.dataLoaded = false;

        self.on('mount', function() {
            getLessons();
            getUser();
        });

        events.on('auth_complete', function() {
            self.user = 1;
            self.update();
        });

        events.on('users_loaded', function(user) {
            getUser();

            self.dataLoaded = false;
            getLessons();
        });

        events.on('devices_loaded', function(devices) {
            self.devices = devices;
            self.update();
        });

        events.on('activities_loaded', function(activities) {
            self.userActivities = activities;
            self.update();
        });

        events.on('navigate_to_lesson', function(payload) {
            const { lesson_id, view, params } = payload || {};
            if (lesson_id && self.lessons) {
                if (lesson_id == "build") {
                    self.showBuildLesson = true;
                    self.selectedLesson = undefined;
                    self.update();
                    return;
                }
                getLoadedLessonById(lesson_id);
                self.update();
            } else if (self.lessons) {
                self.unselectLesson();
            } else {

            }
        });

        events.on('navigate_to_lessons_list', function() {
            self.selectedLesson = undefined;
            self.showBuildLesson = false;
            self.update();
        });

        events.on('navigate_to_lesson_build', function() {
            self.selectedLesson = undefined;
            self.showBuildLesson = true;
            self.editMode = false;
            self.lessonToEdit = undefined;
            self.lessonHasActiveActivity = false;
            self.update();
        });

        events.on('navigate_to_lesson_edit', function(payload) {
            self.selectedLesson = undefined;
            self.showBuildLesson = true;
            self.editMode = true;
            self.lessonToEdit = payload.lesson;
            self.lessonHasActiveActivity = self.lessonHasActivity(payload.lesson);
            self.update();
        });

        this.lessonHasActivity = function(l) {
            if (self.userActivities) {
                for (i = 0; i < self.userActivities.length; i++) {
                    if (self.userActivities[i].lesson_id == l.id && self.userActivities[i].active) {
                        return true;
                    }
                }
            }
            return false;
        }.bind(this)

        self.myLessonsFilterActive = false;

        self.toggleMyLessonsFilter = function() {
            self.myLessonsFilterActive = !self.myLessonsFilterActive;
            self.filterLessons();
        };

        self.toggleCommunityContent = function() {
            self.showCommunityContent = !self.showCommunityContent;
            self.filterLessons();
        };

        this.filterLessons = function(e) {
            var input = document.getElementById('filterLessonsInput');
            var gradeSelect = document.getElementById('gradeFilterSelect');
            var filter = input.value.trim().toLowerCase();
            var selectedGrade = gradeSelect ? gradeSelect.value : '';
            var userId = self.user && self.user.user_id;
            self.filteredLessons = [];
            for (var i = 0; i < self.lessons.length; i++) {
                var lesson = self.lessons[i];

                var matchesText = false;
                if (!filter) {
                    matchesText = true;
                } else {
                    if (lesson.name && lesson.name.toLowerCase().indexOf(filter) > -1) matchesText = true;
                    if (lesson.author && lesson.author.first_name && lesson.author.last_name) {
                        var author = (lesson.author.first_name + ' ' + lesson.author.last_name).toLowerCase();
                        if (author.indexOf(filter) > -1) matchesText = true;
                    }
                    if (lesson.grade_level && lesson.grade_level.toString().indexOf(filter) > -1) matchesText = true;
                }

                var matchesGrade = false;
                if (!selectedGrade) {
                    matchesGrade = true;
                } else if (lesson.grade_level && lesson.grade_level.toString() === selectedGrade) {
                    matchesGrade = true;
                }

                var matchesVisibility = false;
                if (self.myLessonsFilterActive) {
                    if (userId && lesson.author && lesson.author.id == userId) {
                        matchesVisibility = true;
                    }
                } else if (self.showCommunityContent) {
                    matchesVisibility = true;
                } else {
                    matchesVisibility = isOfficialOrMyContent(lesson);
                }

                if (matchesText && matchesGrade && matchesVisibility && self.filteredLessons.indexOf(lesson) === -1) {
                    self.filteredLessons.push(lesson);
                }
            }
            self.update();
        }.bind(this)

        this.activityRefClick = function(e) {
            events.emit('navigate_to_activity', { act_ref: e.item.a.activity_ref });
        }.bind(this)

        this.refreshClick = function(e) {
            self.lessons_error = undefined;
            self.dataLoaded = false;
            getLessons()
        }.bind(this)

        this.clearFilters = function() {
            document.getElementById('filterLessonsInput').value = '';
            document.getElementById('gradeFilterSelect').value = '';
            self.myLessonsFilterActive = false;
            self.filteredLessons = self.showCommunityContent ? self.lessons : self.lessons.filter(function(l) { return isOfficialOrMyContent(l); });
            self.update();
        }.bind(this)

        this.hasActiveFilters = function() {
            var searchInput = document.getElementById('filterLessonsInput');
            var gradeSelect = document.getElementById('gradeFilterSelect');
            var hasSearchText = searchInput && searchInput.value.trim() !== '';
            var hasGradeFilter = gradeSelect && gradeSelect.value !== '';
            var hasMyLessons = !!self.myLessonsFilterActive;
            return hasSearchText || hasGradeFilter || hasMyLessons;
        }.bind(this)

        this.unselectLesson = function() {
            self.selectedLesson = undefined;
            routerHelpers.navigate("lessons");
            self.update();
        }.bind(this)

        this.selectLesson = function(e) {

            routerHelpers.navigate('lessons', e.item.l.id);

        }.bind(this)

        this.startActivityClick = function(e) {

            self.startingActivity = true;
            self.selectLesson(e);
        }.bind(this)

        this.buildLessonClick = function(e) {
            routerHelpers.navigate("lessons", "build");
        }.bind(this)

        this.exitBuildLesson = function() {
            self.showBuildLesson = false;
            self.editMode = false;
            self.lessonToEdit = undefined;
            routerHelpers.navigate("lessons");

            getLessons();
        }.bind(this)

        this.getStatusTag = function(s) {
            if (s == "Inactive") {
                return "light"
            } else if (s == "Error") {
                return "danger"
            } else if (s == "In Unit") {
                return "success"
            } else {
                return "warning"
            }
        }.bind(this)

        function getUser() {
            user_profile = localStorage.getItem('profile');
            if (user_profile != "undefined") {
                self.update({
                    user: JSON.parse(user_profile)
                });
            }
        };

        function extractUniqueGrades(lessons) {
            var grades = [];
            for (var i = 0; i < lessons.length; i++) {
                var grade = lessons[i].grade_level;
                if (grades.indexOf(grade) === -1) {
                    grades.push(grade);
                }
            }
            return grades.sort(function(a, b) { return a - b; });
        }

        function isOfficialOrMyContent(item) {
            if (!item.author) return true;
            var userId = self.user && self.user.user_id;
            if (userId && item.author.id == userId) return true;
            var authorName = ((item.author.first_name || '') + ' ' + (item.author.last_name || '')).toLowerCase().trim();
            if (authorName.indexOf('edjro') > -1 || authorName.indexOf('filament') > -1) return true;
            return false;
        }

        function removeDuplicateLessons(lessons) {
            var uniqueLessons = [];
            var seenIds = [];

            for (var i = 0; i < lessons.length; i++) {
                var lesson = lessons[i];
                if (seenIds.indexOf(lesson.id) === -1) {
                    seenIds.push(lesson.id);
                    uniqueLessons.push(lesson);
                }
            }
            return uniqueLessons;
        }

        function getLoadedLessonById(id) {

            for (i = 0; i < self.lessons.length; i++) {
                if (self.lessons[i].id == id) {
                    self.selectedLesson = self.lessons[i];
                    break;
                }
            }

        }

        function getLessons() {

            if (self.loading_lessons) {
                return;
            }

            self.loading_lessons = true;
            libGetLessons().then(function(res) {
                self.loading_lessons = false;
                self.dataLoaded = true;

                var uniqueLessons = removeDuplicateLessons(res['data']['lessons']);
                var availableGrades = extractUniqueGrades(uniqueLessons);

                var initialFiltered = self.showCommunityContent ? uniqueLessons : uniqueLessons.filter(function(l) { return isOfficialOrMyContent(l); });
                self.update({
                    lessons: uniqueLessons,
                    filteredLessons: initialFiltered,
                    availableGrades: availableGrades,
                    lessons_error: undefined
                });

                window.appData.lessons = uniqueLessons;

                events.emit('lessons_loaded', uniqueLessons);

                route.exec()
            }).catch(function(error) {
                console.error('Lessons Error:' + error);
                self.loading_lessons = false;
                self.dataLoaded = false;
                self.update({
                    lessons: [],
                    filteredLessons: [],
                    lessons_error: error
                });
            });

        }
});
